module.exports = __webpack_public_path__ + "static/media/A12.e13aa4dc.jpg";